import { im as iMRequest, qa as qARequest, roomApi } from '@/request/index.js';
import BaseServer from '@/domain/common/base.server.js';
import useMsgServer from '@/domain/common/msg.server.js';
import useRoomBaseServer from '../room/roombase.server';
import { Domain } from '@/domain';
import VhallPaasSDK from '@/sdk/index.js';
import { debounce, throttling, CNTz2CurTz, safeJsonParse } from '@/utils';

//消息服务
const msgServer = useMsgServer();
let localPassedMsgId = 0
class ChatAuthServer extends BaseServer {
  constructor() {
    if (typeof ChatAuthServer.instance === 'object') {
      return ChatAuthServer.instance;
    }
    super();
    this.state = {
      //房间信息，这里只能通过接口获取
      roomInfo: {
        room_id: '',
        vss_token: ''
      },
      //活动原始信息
      watchInitData: {},
      //基础频道信息
      baseChanelInfo: {
        app_id: '',
        client: 'pc_browser',
        access_token: '',
        channel_id: '',
        third_party_user_id: null, // 支持人的id
        package_check: '1.7.1'
      },
      //操作人员id
      operatorId: '',
      //操作人员的角色
      roleName: '',
      //是否是主持人
      hostUserId: '',
      //活动标题
      activityTitle: '',
      //起始时间
      createTime: '',
      //未审核的消息
      auditList: '',
      //已通过的消息
      passedList: '',

      //禁言列表
      mutedList: '',
      //已踢出列表
      kickedList: '',
      //未审核的数量
      auditNum: 0,
      //已通过总数
      passedNum: 0,
      //已禁言总数
      mutedNum: 0,
      //已踢出的总数
      kickedNum: 0,
      //是否开启聊天审核
      enableChatAuth: 1,
      //是否开启自动审核
      enableAutoHandle: '1',
      //收到消息后是否加入列表
      // isUpdate: true,
      //消息加入位置是头还是尾
      orderBy: 'asc', //asc默认正序，desc倒序'
      isStopAdd: false,//是否停止往已通过消息列表中追加消息，处理停留某条消息场景
      chatMsgRecommend: null,//精选消息
      bucketSwitch: 1, //是否开启消息分桶 1开启 0关闭
    };

    // 聊天sdk实例
    this.chatInstance = null;
    this.MSGQUEUE = [],//待审核消息待处理队列
      this.passedMSGQUEUE = [],//已通过消息待处理队列
      //接收自定义消息的sdk实例
      this.customChatInstance = null;
    ChatAuthServer.instance = this;
    return this;
  }

  /**
   * 初始化方法
   * */
  init() {

  }

  /**
   * 设置state中的值
   * */
  setState(key, value) {
    !['', null, void (0)].includes(key) && (this.state[key] = value);
  }

  /**
   * 初始化监听事件
   * */
  listenEvents() {
    this.chatInstance.on(msg => {
      // console.log(msg, 'chat的msg');
      if (typeof msg.data !== 'object') {

        msg.data = ![null, void (0), ''].includes(msg.context) ? safeJsonParse(msg.data) : '';
        msg.context = ![null, void (0), ''].includes(msg.context) ? safeJsonParse(msg.context) : '';
      }
      const type = msg.data.type;
      switch (type) {
        case 'disable': // 禁言
          this.state.mutedList.unshift({ account_id: msg.data.target_id, nickname: msg.data.nick_name, updated_at: msg.date_time });
          this.operateUser(msg.data.target_id, type);
          break;
        case 'permit': // 取消禁言
          this.state.mutedList = this.state.mutedList.filter(item => {
            if (item.account_id == msg.data.target_id && this.state.mutedNum > 0) {
              this.state.mutedNum--
            }
            return item.account_id !== msg.data.target_id;
          });
          break
        case 'text':
        case 'image':
          this.state.passedNum++;
          this.$emit("receivePassedMsg")
          if (this.state.isStopAdd) {
            return
          }
          Object.assign(msg, msg.data, msg.context, { date_time: CNTz2CurTz(msg.date_time) })
          if (this.state.isStopAdd) {
            return
          }

          msg.local_id = localPassedMsgId++;
          this.passedMSGQUEUE.push(msg);
          this.throttleAdPassedMsg()

          break;
        default:
          break;
      }
    });
    this.chatInstance.onRoomMsg(msg => {
      let temp = Object.assign({}, msg);
      if (typeof temp.data !== 'object') {
        temp.data = ![null, void (0), ''].includes(temp.context) ? JSON.parse(temp.data) : '';
        temp.context = ![null, void (0), ''].includes(temp.context) ? JSON.parse(temp.context) : '';
      }
      console.log(temp, '房间消息');
      const type = temp.data.type;
      switch (type) {
        case 'room_kickout': // 踢出
          if (temp.data.kick_type == 0) {
            this.state.kickedList.unshift({
              account_id: temp.data.target_id, nickname: temp.data.nick_name,
              updated_at: temp.data.push_time
            })
            this.operateUser(temp.data.target_id, type);
          }

          break;
        case 'room_kickout_cancel':
          if (temp.data.kick_type == 0) {
            this.state.kickedList = this.state.kickedList.filter(item => {
              if (item.account_id == temp.data.target_id && this.state.kickedNum > 0) { this.state.kickedNum-- }
              return item.account_id !== temp.data.target_id;
            });
          }
          break;
        case 'chat_delete':
          const ids = temp.data.msg_ids.split(',')
          for (let i = this.state.passedList.length - 1; i >= 0; i--) {
            if (ids.includes(this.state.passedList[i].msg_id)) {
              this.state.passedList.splice(i, 1);
            }
          }
          this.state.passedNum > 0 && this.state.passedNum--
          break;
        case 'chat_msg_set_recommend': //精选消息
          this.state.chatMsgRecommend = {
            msg_id: rawMsg.data.msg_id,
            msg_content: rawMsg.data.msg_content,
          }
          this.$emit("recommendChatMsg", this.state.chatMsgRecommend)
          break;
        case 'chat_msg_del_recommend'://取消精选消息
          this.state.chatMsgRecommend = null;
          this.$emit("cancelRecommendChatMsg", this.state.chatMsgRecommend)
          break;
        case 'chat_review_config':
          const data = JSON.parse(temp.data.content || "{}")
          this.$emit("chatReviewConfig", data)
          break;
      }
    });
  }

  /**
   * 注册监听自定义消息的回调
   * */
  listenCustomMsg() {
    this.customChatInstance.onCustomMsg(msg => {
      let temp = Object.assign({}, msg);
      if (typeof temp.data !== 'object') {
        temp.data = ![null, void (0), ''].includes(temp.data) ? JSON.parse(temp.data) : '';
        temp.context = ![null, void (0), ''].includes(temp.context) ? JSON.parse(temp.context) : '';
      }
      const operate = temp.data.operation_status;
      console.log(temp, '收到自定义消息', msg.msg_id);
      switch (operate) {
        case 1:
          Object.assign(temp.data, {
            isOperate: 0,
            join_id: temp.sender_id,
            nick_name: temp.context.nick_name || temp.context.nickname,
            role_name: temp.context.role_name,
            extra_identity: temp.context.extra_identity,
            is_chatbot: temp.context.is_chatbot,
            time: CNTz2CurTz(temp.data.time)
          });
          this.state.auditNum++
          // if (this.state.isUpdate) {
          this.$emit("receiveAuditMsg", temp.data)
          this.MSGQUEUE.push(temp.data)
          this.throttleAddMsg()
          // }
          break;
        case 2:
          // 开启留言审核、自动阻止、自动发送
          // if (temp.data.third_party_user_id === this.state.operatorId) {
          //   return;
          // }
          this.state.enableChatAuth = parseInt(temp.data.switch);
          this.$emit('updateAuthSwitch', { enableChatAuth: this.state.enableChatAuth, bucketSwitch: temp.data.bucket_switch })
          this.state.bucketSwitch = temp.data.bucket_switch
          if (temp.data.switch_options) {
            this.state.enableAutoHandle = temp.data.switch_options
            this.$emit("updateAuthSettings", {
              enableAutoHandle: this.state.enableAutoHandle,
              overLimitCount: temp.data.over_limit_count,
            })
          }
          break;
        case 5:
          // 通过、全部通过、阻止、全部阻止
          if (!Object.prototype.hasOwnProperty.call(temp.data, 'msg_id')) {
            return;
          }
          const count = temp.data.msg_id.split(',').length
          // temp.data.status === 1 && (this.state.passedNum += count);
          temp.data.third_party_user_id == this.state.baseChanelInfo.third_party_user_id && this.state.auditNum >= count && (this.state.auditNum -= count)
          //更新数据操作状态
          // this.state.auditList.forEach(item => {
          //   (temp.data.msg_id || '').split(',').forEach(it => {
          //     if (item.msg_id === it) {
          //       item.isOperate = parseInt(temp.data.status);
          //       if (item.isOperate === 1) {
          //         this.state.passedNum++;
          //       }
          //     }
          //   });
          // });
          break;
        default:
          break;
      }
    });
    this.customChatInstance.join(msg => {
      if (msg.sender_id != this.state.baseChanelInfo.third_party_user_id) {
        this.throttleReviewerChange()
      }
    })
    this.customChatInstance.leave(msg => {
      if (msg.sender_id != this.state.baseChanelInfo.third_party_user_id) {
        this.throttleReviewerChange()
      }
    })
  }
  throttleReviewerChange = throttling(() => {
    this.$emit("reviewerChange")
  }, 5000)
  /**
   * 初始化房间信息，聊天实例等
   * */
  initRoomInfo(params = {}) {
    return this.getRoomInfo(params)
      .then(res => {
        console.warn('获取到的关键信息点---', res.data);
        //保存一份活动信息
        this.state.watchInitData = Object.assign(res.data || {});
        const { interact = {}, join_info = {}, webinar = {} } = res.data || {};
        this.state.roomInfo.room_id = interact.room_id;
        this.state.roomInfo.vss_token = interact.paas_access_token;
        this.state.operatorId = join_info.third_party_user_id;
        this.state.activityTitle = webinar.subject;
        this.state.roleName = join_info.role_name;
        this.state.hostUserId = webinar.userinfo.user_id; // 是否是主持人
        this.state.createTime = '2020-12-09 19:52:00'.split(' ')[0].split('-').join('/');
        // appId 必须
        this.state.baseChanelInfo.app_id = interact.paas_app_id;
        // 第三方用户ID
        this.state.baseChanelInfo.third_party_user_id = join_info.third_party_user_id;
        // 必须， token，初始化接口获取
        this.state.baseChanelInfo.access_token = interact.paas_access_token;
        // 频道id 必须
        this.state.baseChanelInfo.channel_id = interact.channel_id;
        return res;
      });
  }

  // 初始化聊天实例
  async initChatInstance(embedInLive = false) {
    //todo 询问一下为啥频道id一个是ck+频道id ,一个就是单纯的频道id
    const options = {
      appId: this.state.baseChanelInfo.app_id, // appId 必须
      accountId: this.state.baseChanelInfo.third_party_user_id, // 第三方用户ID
      channelId: this.state.baseChanelInfo.channel_id, // 频道id 必须
      token: this.state.baseChanelInfo.access_token, // 必须， token，初始化接口获取
      hide: true
    };

    // 创建domain实例
    !embedInLive && await new Domain({
      plugins: ['chat'],
      isNotInitRoom: true
    });

    const customChatInstance = new Promise((resolve, reject) => {
      VhallPaasSDK.modules.VhallChat.createInstance(
        Object.assign({}, options, { channelId: ['ck_', options.channelId].join(''), hide: false }),
        event => {
          // 互动实例
          this.customChatInstance = event.message;
          this.listenCustomMsg();
          resolve(event);
        },
        error => {
          reject(error);
        }
      );
    });
    await customChatInstance;
    return new Promise((resolve, reject) => {
      if (embedInLive) {
        this.chatInstance = msgServer.msgInstance;
        this.listenEvents();
        resolve()
      } else {
        VhallPaasSDK.modules.VhallChat.createInstance(
          options,
          event => {
            // 互动实例
            this.chatInstance = event.message;
            this.listenEvents();
            resolve(event);
          },
          error => {
            reject(error);
          }
        );
      }

    });

  }
  throttleAddMsg = throttling(() => {
    this.state.orderBy == "asc" ? this.state.auditList.push(...this.MSGQUEUE) : this.state.auditList.unshift(...(this.MSGQUEUE.reverse()))
    this.MSGQUEUE.length = 0
    this.$emit('auditListUpdate', 123);
  }, 1000)
  throttleAdPassedMsg = throttling(() => {
    this.state.passedList.push(...this.passedMSGQUEUE)
    if (this.state.passedList.length > 50) {
      this.state.passedList.splice(0, this.state.passedList.length - 50)
    }
    this.passedMSGQUEUE.length = 0
    this.$emit('passedListUpdate');
  }, 1000)
  /**
   * 获取房间信息
   * */
  getRoomInfo(params = {}) {
    return qARequest.list.initChatMess(params);
  }
  // setIsUpdate(flag) {
  //   this.state.isUpdate = flag
  // }
  /**
   * 获取未审核的列表
   * */
  fetchChatMessageList(searchForm = {}) {
    this.searchForm = searchForm;
    searchForm.order_by && (this.state.orderBy = searchForm.order_by)
    const { baseChanelInfo = {} } = this.state || {};
    const params = Object.assign({}, baseChanelInfo, searchForm);
    this.state.auditList = [];
    let tempItem = {};
    let object = {};
    let context, data;
    return this.getAuditMessageList(params).then(res => {
      this.state.auditList = [];
      for (let i in (res.data || {})) {
        object = JSON.parse(res.data[i]);
        context =
          typeof JSON.parse(object.context) === 'object'
            ? JSON.parse(object.context)
            : JSON.parse(JSON.parse(object.context));
        tempItem.nick_name = context.nickname || context.nick_name;
        tempItem.role_name = context.role_name;
        tempItem.extra_identity = context.extra_identity;  //是否是AI聊天机器人
        tempItem.is_chatbot = context.is_chatbot;  //是否是AI聊天机器人
        tempItem.time = CNTz2CurTz(object.time); // 发送时间为中国时间，转为当前时区时间
        tempItem.type = object.type;
        tempItem.msg_id = i;
        tempItem.third_party_user_id = object.sender_id; // 发送消息的人第三方id
        tempItem.channel = object.channel;
        tempItem.room_id = object.room_id;
        data = JSON.parse(object.data);
        if (tempItem.type === 'text') {
          tempItem.text_content = data.barrageTxt || data.text_content;
        } else if (tempItem.type === 'video') {
          tempItem.video_url = data.video_url;
        } else if (tempItem.type === 'voice') {
          tempItem.voice_url = data.voice_url;
        } else if (tempItem.type === 'image') {
          tempItem.image_urls = data.image_urls;
          if (Object.prototype.hasOwnProperty.call(data, 'text_content')) {
            tempItem.text_content = data.barrageTxt || data.text_content;
          }
        } else if (tempItem.type === 'link') {
          tempItem.link_url = data.link_url;
        }
        tempItem.isOperate = 0; // 0 未对数据操作， 1审核通过，2拒绝
        this.state.auditList.push(tempItem);
        tempItem = {};
        object = {};
      }
      !params.keyword && (this.state.auditNum = this.state.auditList.length)
      this.$emit('auditListUpdate', this.state.auditList);
      return this.state.auditList

    });
  }

  /**
   * 获取已通过审核的列表
   * */
  async fetchPassedMessageList(params = {}) {
    const { baseChanelInfo = {}, createTime = '' } = this.state;
    const defaultParams = {
      ...baseChanelInfo,
      msg_type: 'image,text,link,video,voice',
      start_time: createTime
    };
    Object.assign(defaultParams, params);
    //查询状态拉历史直接终止
    if (defaultParams.keyword && params.msg_id) {
      return
    }
    const res = defaultParams.keyword ? await this.getPassedMessageList(defaultParams) : await iMRequest.chat.getChatList({ room_id: this.state.roomInfo.room_id, ...params })

    // 遍历已通过列表，将消息时间转为当前时区时间
    const arr = (res.data.list
      ? res.data.list.map(item => {
        if (!defaultParams.keyword) {
          Object.assign(item, item.data)
        }
        Object.assign(item, { date_time: CNTz2CurTz(item.date_time) })
        item.local_id = localPassedMsgId++
        return item
      })
      : []).reverse();
    this.passedMSGQUEUE.length = 0;
    if (params.anchor_path) {
      this.state.passedList.unshift(...arr)
    } else {
      this.state.passedList = arr
    }
    !defaultParams.keyword && !params.msg_id && (this.state.passedNum = res.data.total || 0);
    return res.data

  }

  /**
   * 获取已禁言的用户列表
   * */
  fetchMutedUserList(params = {}) {
    const { roomInfo = {} } = this.state;
    const requestParams = Object.assign({}, { ...roomInfo }, params);
    return this.getBannedList(requestParams).then(res => {
      this.state.mutedList = res.data.list || [];
      !requestParams.keyword && (this.state.mutedNum = res.data.total || 0);
    });
  }

  /**
   * 获取已踢出的用户列表
   * */
  fetchKickedUserList(params = {}) {
    const { roomInfo = {} } = this.state;
    const requestParams = Object.assign({}, { ...roomInfo }, params);
    return this.getKickedList(requestParams).then(res => {
      this.state.kickedList = res.data.list || [];
      !requestParams.keyword && (this.state.kickedNum = res.data.total || 0);
    });
  }
  //获取已阻止消息列表
  fetchBlockedList(params = {}) {
    const { roomInfo = {}, baseChanelInfo = {} } = this.state;
    const requestParams = Object.assign({}, roomInfo, baseChanelInfo, params);
    return iMRequest.chatAuth.getBlockedList(requestParams);
  }

  /**
   * 
   * */
  operateUser(id, type) {
    //更新tab栏上的未读数
    if (type === 'room_kickout') {
      this.state.kickedNum++;
    } else if (type === 'disable') {
      this.state.mutedNum++;
    }
    const params = {
      ...this.state.baseChanelInfo,
      msg_id: '',
      status: 2,
      range_type: 0
    };
    //处理待审核被踢出或禁言的聊天数据
    this.getAuditMessageList(Object.assign({}, this.state.baseChanelInfo, this.searchForm)).then(res => {
      if (res?.data) {
        const obj = res.data;
        for (const key in obj) {
          // 建议加上判断，只遍历对象自身的属性（排除继承的属性）
          if (obj.hasOwnProperty(key)) {
            const item = JSON.parse(obj[key])
            if (item.sender_id === id) {
              params.msg_id += key + ',';
            }
          }
        }
        this.fetchOperate(params);
      }
    })
  }

  //操作消息
  fetchOperate(params, cb) {
    if (!params.msg_id) return;
    this.operateMessage(params)
      .finally(() => {
        this.fetchChatMessageList(this.searchForm);
      });
  }
  //删除某条已通过的聊天消息
  async deleteMessage(params = {}) {
    params.room_id = this.state.roomInfo.room_id
    const res = await iMRequest.chat.deleteMessage(params);
    if (res.code == 200) {
      const _index = this.state.passedList.findIndex(chatMsg => {
        return chatMsg.msg_id === params.msg_id;
      });
      _index > -1 && this.state.passedList.splice(_index, 1);
      this.passedNum > 0 && this.passedNum--;
    }
    return res

  }
  /**
   * 通过、全部通过、阻止、全部阻止的时候更新对应数据状态
   * */

  /**
   * 开启/关闭聊天审核
   * /sdk/v2/message/set-channel-switch
   * */
  toggleChatAuthStatus(params = {}) {
    return iMRequest.chatAuth.toggleChatAuthStatus(params);
  }

  /**
   * 获取聊天审核列表
   * /sdk/v2/message/get-chat-audit-lists
   * */
  getAuditMessageList(params = {}) {
    return iMRequest.chatAuth.getChatAuditList(params);
  }

  /**
   * 获取已通过列表
   * /sdk/v2/message/lists
   * */
  getPassedMessageList(params = {}) {
    return iMRequest.chatAuth.getPassedMessageList(params);
  }

  /**
   * 获取禁言列表
   * /v3/interacts/chat-user/get-banned-list
   * */
  getBannedList(params = {}) {
    return iMRequest.chat.getBannedList(params);
  }

  /**
   * 获取踢出列表
   * /v3/interacts/chat-user/get-kicked-list
   * */
  getKickedList(params = {}) {
    return iMRequest.chat.getKickedList(params);
  }

  /**
   * 对消息进行操作 (通过、阻止、通过并回复,全部阻止，全部通过)
   * /sdk/v2/message/apply-message-send
   * */
  operateMessage(params = {}) {
    return iMRequest.chatAuth.applyMessageSend(params);
  }

  /**
   * 过滤设置开关 （过滤设置：未审核超过200条时自动发送 / 阻止）
   * /sdk/v2/message/set-channel-switch-options
   * */
  setMessageFilterOptions(params = {}) {
    return iMRequest.chatAuth.setMessageFilterOptions(params);
  }

  /**
   * 获取聊天设置开关状态
   * */
  getChatAuthEnableStatus(params = {}) {
    return iMRequest.chatAuth.getChatAuthStatus(params).then(res => {
      this.state.bucketSwitch = res.data.bucket_switch
      return res
    });
  }

  /**
   * 取消禁言/禁言
   * /v3/interacts/chat-user/set-banned
   * */
  toggleBannedStatus(params = {}) {
    return iMRequest.chat.setBanned(params);
  }

  /**
   * 取消踢出/踢出
   * /v3/interacts/chat-user/set-kicked
   * */
  toggleKickedStatus(params = {}) {
    return iMRequest.chat.setKicked(params);
  }
  //设置ai聊天审核权限
  setChatAuth(params = {}) {
    return roomApi.base.setInfoInWebinar(params);
  }
  //获取ai聊天审核权限配置
  getAIAuth(params = {}) {
    return roomApi.base.getInfoInWebinar(params);
  }
  //请求全局踢出列表
  getGlobalKickedList(params = {}) {
    return iMRequest.chat.getGlobalKickedList(params);
  }
  addKickedUser(params = {}) {
    return iMRequest.chat.addKickedUser(params);
  }
  delKickedUser(params = {}) {
    return iMRequest.chat.delKickedUser(params);
  }
  //设置精选消息
  async handleRecommendMsg(params) {
    const res = await iMRequest.chat.recommendMsg(params);
    if (res.code == 200) {
      if (params.recommend_status == 1) {
        this.state.chatMsgRecommend = { msg_id: params.msg_id, msg_content: params.msg_content }
      } else {
        this.state.chatMsgRecommend = null
      }
    }
    return res
  }
}

export default function useChatAuthServer() {
  return new ChatAuthServer();
}